import Vue from 'vue'
import GlobalSearch from '@/pages/globalSearch/GlobalSearch.vue'
import { getGlobalSearchResult } from '@/api/globalSearch'
import Fuse from 'fuse.js'

document.addEventListener('DOMContentLoaded', () => {
    const id = 'global-search'
    const el = document.getElementById(id)
    if (el) {
        const staticResults =
            JSON.parse(el.getAttribute('data-static-results') || '') || {}
        const options = {
            keys: ['title', 'subtitle', 'description'],
            shouldSort: true,
            threshold: 0.4,
            location: 0,
            distance: 100,
            maxPatternLength: 32,
            minMatchCharLength: 3,
        }
        new Vue({
            name: 'GlobalSearch',
            render: (h) =>
                h(GlobalSearch, {
                    props: {
                        search: async (keyword: string) => {
                            // const staticResults =
                            const results = { ...staticResults }
                            if (keyword) {
                                // search server side for responses
                                const { data } = await getGlobalSearchResult(
                                    keyword
                                )
                                // search locally through
                                if (
                                    results['Last Visited'] &&
                                    results['Last Visited'].length
                                ) {
                                    // merge last visted list to search results, so to get more accurate results
                                    results['Search Results'] = results[
                                        'Search Results'
                                    ].concat(results['Last Visited'])
                                }
                                results['Last Visited'] = [] // ignore last visited when keyword not empty
                                const fuse = new Fuse(
                                    results['Search Results'],
                                    options
                                )
                                results['Search Results'] = fuse.search(keyword)
                                results['Search Results'] =
                                    results['Search Results'].concat(data)
                            }
                            return results
                        },
                    },
                }),
        }).$mount('#' + id)
    }
})
